import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-red-600 text-white px-3 py-1 rounded font-bold">
                LUKOIL
              </div>
              <div className="text-red-600 font-bold text-lg">
                EKTO
              </div>
            </div>
            <p className="text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-red-500 transition-colors text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/stations" className="hover:text-red-500 transition-colors text-sm">
                  {t('nav.stations')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-red-500 transition-colors text-sm">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="hover:text-red-500 transition-colors text-sm">
                  {t('nav.reviews')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-red-500 transition-colors text-sm">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('contact.info')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <Phone className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <a href="tel:+994559883030" className="hover:text-red-500 transition-colors">
                  {t('header.phone')}
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <Mail className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <a href="mailto:ekto.lukoil@gmail.com" className="hover:text-red-500 transition-colors break-all">
                  {t('header.email')}
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <span>Azerbaijan</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <Clock className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <span>24/7</span>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('stations.hours')}</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>{t('stats.service')}</span>
                <span className="text-red-500 font-semibold">24/7</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p>© {currentYear} LUKOIL EKTO Azerbaijan. {t('footer.rights')}.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
